export default __webpack_public_path__ + "static/media/cardReceiveBlack.d17159db.svg";